import * as React from 'react';

import * as styles from './styles.css';
import { IAiSummaryNewbuilding } from '../../../AiSummaryModalDesktop/types';
import { Image } from '@cian/ui-kit';
import clsx from 'clsx';

export interface IMobileNavbarProps {
  activeNewbuildingId: number;
  items: IAiSummaryNewbuilding[];
  onSelectNewbuilding: (id: number) => void;
}

export const MobileNavbar = ({
  activeNewbuildingId,
  items,
  onSelectNewbuilding,
}: IMobileNavbarProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      {items.map(item => {
        const isActive = activeNewbuildingId === item.id;

        return (
          <div
            className={clsx(styles['image-wrapper'], isActive && styles['active-border'])}
            data-testid={`ai-summary-tab-${item.id}`}
            key={item.id}
            onClick={() => onSelectNewbuilding(item.id)}
          >
            <Image borderRadius="8px" height={36} src={item.imageUrl} width={36} />
          </div>
        );
      })}
    </div>
  );
};
